import React from "react";

import { ApolloProvider } from "@apollo/react-hooks";
import AWSAppSyncClient from "aws-appsync";
import Amplify, { Analytics } from "aws-amplify";

import config from "../../aws-exports";

Amplify.configure(config);
Analytics.configure({
  disabled: false,
  autoSessionRecord: true,
  AWSPinpoint: {
    appId: config.aws_mobile_analytics_app_id,
    region: "us-east-1",
    bufferSize: 1000,
    flushInterval: 5000, // 5s
    flushSize: 100,
    resendLimit: 5,
  },
});
const client = new AWSAppSyncClient({
  url: config.aws_appsync_graphqlEndpoint,
  region: config.aws_appsync_region,
  auth: {
    apiKey: config.aws_appsync_apiKey,
    type: config.aws_appsync_authenticationType as any,
  },
  disableOffline: true,
  cacheOptions: {},
});

export const DataProvider: React.FC = (props) => (
  <ApolloProvider client={client as any}>{props.children}</ApolloProvider>
);
